import {WithdrawalMethodInterface} from 'typings';

export const isWithdrawalMethodAvailable = (method: WithdrawalMethodInterface): boolean => {
    // return !method?.isDisable || (!!method?.isDisable && method?.key === WithdrawalMethodsEnum.CARD && isRegionRu);
    return !method?.isDisable;
};
